export { default } from './ConfirmModal';
export { default as ConfirmModal } from './ConfirmModal';
export { ConfirmModalStyle } from './ConfirmModal';
